// extracted by mini-css-extract-plugin
module.exports = {"embedWrapper":"video-module--embedWrapper--K6mBv"};